import { LIBRARY_VERSION } from './consts.mjs';
import { fetchWithTimeout } from './fetch-with-timeout.mjs';
import { generateCreateBrowserIdUrl } from './url-builder.mjs';

/**
 * Gets the browser ID from Sitecore CDP
 * @param targetURL - From global settings
 * @param clientKey - From global settings
 * @returns the browser ID
 */
async function getBrowserIdFromCdp(targetURL, clientKey, timeout) {
    const fetchOptions = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        headers: { 'X-Library-Version': LIBRARY_VERSION },
    };
    let response;
    if (timeout !== undefined) {
        response = await fetchWithTimeout(generateCreateBrowserIdUrl(targetURL, clientKey), timeout, fetchOptions);
    }
    else {
        response = await fetch(generateCreateBrowserIdUrl(targetURL, clientKey), fetchOptions)
            .then((res) => res.json())
            .then((data) => data)
            .catch(() => undefined);
    }
    if (!response)
        return '';
    const { ref } = response;
    return ref;
}

export { getBrowserIdFromCdp };
